import React from "react";
import {
  Paper,
  InputBase,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { FilterSelect } from "../CustomSelectBox";
import styles from "./styles";

let searchTimeout = null;

const ControlledSearchBox = ({
  placeholder = "Search",
  handleSearch = () => {},
  onChange = () => {},
  multiple = true,
  fields = [],
  selectedFields = [],
  value,
}) => {
  const classes = styles();

  const handleChange = ({ target: { value = "" } }) => {
    handleSearch(value);
  };

  const triggerSearch = (val = "") => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
    }, 1000);
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch(value);
      }}
    >
      <Paper className={classes.searchBar}>
        <InputBase
          value={value}
          onChange={handleChange}
          className={classes.input}
          placeholder={placeholder}
        />

        {fields.length > 1 && (
          <FilterSelect
            multiple={multiple}
            fields={fields}
            selectedFields={selectedFields}
            onChange={onChange}
          />
        )}
        <IconButton
          className={classes.iconButton}
          aria-label="search"
          onClick={(e) => {
            handleSearch(value.trim());
          }}
          size="large">
          <SearchIcon className={classes.icon} />
        </IconButton>
      </Paper>
    </form>
  );
};

export default ControlledSearchBox;
